export default "__VITE_ASSET__4edca354__"